var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" Chop Sumo is a series of 3 000 unique NFT sumo characters, created exclusively in 3D. Each SUMO is diligently programmed and randomly generated living on Tezos! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }